import React, { FC, useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Exporting from "highcharts/modules/exporting";
import OfflineExporting from "highcharts/modules/offline-exporting";

Exporting(Highcharts);
OfflineExporting(Highcharts);
interface CustomBarChartComponentProps {
  data: { name: string; y: number }[];
  onClickSlice?: (event: any) => void;
  fileName?: string;
  chartName?: string;
}

const CustomBarChartComponent: FC<CustomBarChartComponentProps> = ({
  data,
  onClickSlice,
  fileName,
  chartName,
}) => {
  const [customHighChartOptions, setCustomHighChartOptions] = useState({});
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  useEffect(() => {
    const chartOptions: Highcharts.Options = {
      chart: {
        type: "bar",
        style: {
          fontFamily: '"Cabin", Helvetica, Arial, sans-serif',
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
      },
      xAxis: {
        categories: data?.map((item: any) => item.name),
        title: {
          text: "Usage Distribution",
          style: {
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Luminaire Quantity",
          style: {
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
        allowDecimals: false
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            filter: {
              property: "y",
              operator: "!=",
              value: 0,
            },
            format: "{y}",
          },
          events: {
            click: function (event: any) {
              if (onClickSlice) {
                onClickSlice(event);
              }
            },
          },
          cursor: "pointer",
        },
      },
      exporting: {
        enabled: true,
        fallbackToExportServer: false,
        filename: fileName || "chart",
        sourceWidth: 1200, // Increase source dimensions
        sourceHeight: 500,
        scale: 1, // Maintain original scale
        chartOptions: chartName
          ? {
            chart: {
              height: "100%", // Use relative height
              width: "100%", // Use relative width
              spacingTop: 30, // Add more space at the top for the title
              marginTop: 100, // Increase the top margin to push chart content down
            },
            title: {
              text: chartName, // Dynamic title from prop
              align: "center",
              margin: 20,
              style: {
                fontSize: "24px",
                fontWeight: "bold",
              },
            },
          }
          : {
            chart: {
              height: "100%", // Use relative height
              width: "100%", // Use relative width
            },
            title: {
              style: {
                fontSize: "14px",
              },
            },
          },
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
            ],
          },
        },
      },
      series: [
        {
          type: "bar",
          name: "Quantity",
          data: data?.map((item) => item.y),
          color: "#66b2ff",
        },
      ],
    };

    setCustomHighChartOptions(chartOptions);
  }, [data]);

  return (
    <div>
      {customHighChartOptions && data?.length ? (
        <HighchartsReact
          highcharts={Highcharts}
          options={customHighChartOptions}
          ref={chartComponentRef}
        />
      ) : (
        <div
          style={{
            height: "400px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#D9D9D9",
            fontSize: "22px",
            fontWeight: "600",
            color: "#6d6d6d",
          }}
        >
          No Data Available
        </div>
      )}
    </div>
  );
};

export default CustomBarChartComponent;
